exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".display-control-container---3oo8J {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 100%;\n          flex: 1 1 100%;\n  overflow: auto;\n  margin: 20px;\n  padding: 20px;\n  border-radius: 12px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px rgba(0, 0, 0, .07);\n          box-shadow: 5px 5px rgba(0, 0, 0, .07);\n  font-family: poppins, Arial, sans-serif;\n  color: #4e5c67;\n  border: 0 solid #fff; }\n", ""]);

// exports
exports.locals = {
	"display-control-container": "display-control-container---3oo8J"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/display-control-container/display-control-container.scss
// module id = sou6
// module chunks = 1